import React from "react";

export function Demo6Dashboard() {
  return <></>;
}
